import { FC } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: React.ReactNode;
  visible?: boolean;
  onClose?: () => void;
  selector: string;
}
const ClientPortal: FC<Props> = ({ children, selector, visible }) => {
  if (!visible) return null;

  const isDocumentAccessible = typeof document !== 'undefined';

  const targetElement = isDocumentAccessible ? document.getElementById(selector) : null;

  return targetElement ? createPortal(children, targetElement) : null;
};

export default ClientPortal;
